// extracted by mini-css-extract-plugin
export var actionButton = "_kf-0";
export var actionMenuContainer = "_kf-i";
export var bubble = "_kf-2";
export var bubbleActionMenu = "_kf-j";
export var bubbleContext = "_kf-6";
export var bubbleItems = "_kf-7";
export var customer = "_kf-3";
export var divider = "_kf-8";
export var fileList = "_kf-9";
export var hiddenComment = "_kf-o";
export var infoAbove = "_kf-a";
export var internal = "_kf-4";
export var lightActionButton = "_kf-1";
export var link = "_kf-b";
export var merchant = "_kf-5";
export var message = "_kf-c";
export var profilePicture = "_kf-e";
export var quillToolbarContainer = "_kf-f";
export var senderDate = "_kf-g";
export var senderDateCustomer = "_kf-h";
export var senderName = "_kf-d";
export var time = "_kf-k";
export var uploadedImage = "_kf-l";
export var username = "_kf-m";
export var xsmall = "_kf-n";